export const getSubscriptionDuration = (input?: string): [string, string] => {
	if (input == undefined) return ["", ""];

	const durationMap: { [key: string]: string } = {
		m: "month",
		w: "week",
		d: "day",
		y: "year",
		q: "quarter",
	};

	const match = input.match(/^(\d+)([mwdyq])$/);
	if (match) {
		const numericValue = parseInt(match[1]);
		const unit = match[2];

		const unitLabel = durationMap[unit];
		if (unitLabel) {
			return [numericValue > 1 ? `${numericValue} ` : "", `${unitLabel}${numericValue > 1 ? "s" : ""}`];
		}
	}

	return [input, ""];
};

export function appendDurationPeriodToPlanName(planName: string, duration: string) {
	const durationMap: { [key: string]: string } = {
		m: " - Monthly",
		w: " - Weekly",
		d: " - Daily",
		y: " - Annual",
		q: " - Quarterly",
	};

	const match = duration.match(/^(\d+)([mwdyq])$/);
	if (match) {
		const unit = match[2];

		const unitLabel = durationMap[unit];
		if (unitLabel) {
			return planName + unitLabel;
		}
	}
}
